import { render, staticRenderFns } from "./QuestionEdit.vue?vue&type=template&id=405a0f41&scoped=true"
import script from "./QuestionEdit.vue?vue&type=script&lang=js"
export * from "./QuestionEdit.vue?vue&type=script&lang=js"
import style0 from "./QuestionEdit.vue?vue&type=style&index=0&id=405a0f41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405a0f41",
  null
  
)

export default component.exports